// AssistantMessage organism (Layer 5 §3.8).
//
// Sprint ai-elements-rendering (spec §3.1) — the markdown body renders
// through the AI Elements `MessageResponse` (which wraps our
// MarkdownRenderer, keeping DocPathChip interleaving per D-012). The
// model badge (shown when ≥2 models appear in history) is our extension;
// the template has no equivalent.

import type { Message } from '../../types';
import { asAssistantText, shortenModel } from '../../lib/messages';
import { MessageResponse } from '../ai-elements/message';
import { useDocViewer } from '../../hooks/useDocViewer';

export interface AssistantMessageProps {
  message: Message;
  showModelBadge?: boolean;
}

export function AssistantMessage({
  message,
  showModelBadge,
}: AssistantMessageProps) {
  const c = asAssistantText(message);
  const { openDoc } = useDocViewer();
  // Sprint context-limit-survivable (D-C3) — `null` for any string that is
  // not a recognised model id, so `<synthetic>` (and every future non-model
  // tag) yields NO badge instead of leaking verbatim.
  const modelLabel = c.model ? shortenModel(c.model) : null;
  return (
    <div data-testid="assistant-text">
      <MessageResponse
        className="max-w-none text-chat text-foreground leading-relaxed"
        onDocPathClick={openDoc}
      >
        {c.text}
      </MessageResponse>
      {showModelBadge && modelLabel && (
        <div
          className="mt-1 text-caption text-muted-foreground/70"
          data-testid="assistant-model-badge"
        >
          {modelLabel}
        </div>
      )}
    </div>
  );
}
